<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="申请时间">
          <el-date-picker
            class="long_date_box"
            v-model="formInline.applyTime"
            type="datetimerange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="办理时间">
          <el-date-picker
            class="long_date_box"
            
            v-model="formInline.dealTime"
            type="datetimerange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="企业名">
          <el-input
            v-model="formInline.company_name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-link style="margin-bottom: 20px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
    >
      <el-table-column prop="company_name" label="填报单位" align="center">
      </el-table-column>
      <el-table-column label="报表名" align="center">
        <template slot-scope="scope">
          <span class="detail" @click="toDetail(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date_range" label="填报期" align="center">
        <template slot-scope="scope">
          <span>{{ getDateRange(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="apply_time_format" label="申请时间" align="center">
      </el-table-column>
      <el-table-column prop="apply_reason" label="申请修改原因" align="center">
      </el-table-column>
      <el-table-column
        prop="handle_time_format"
        label="办理时间"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="handle_reason" label="办理意见" align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class="dialog770 titleChange"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="handleDetail(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <!-- <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[20, 30, 50, 100]"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      v-if="showDialogVisible"
      title="报表详情"
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      width="1160px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow
        v-if="editCode == '001'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></zdquczbShow>
      <zdjcqycwbShow
        v-if="editCode == '002'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></zdjcqycwbShow>
      <gyyqjbqkbShow
        v-if="editCode == '003'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></gyyqjbqkbShow>
    </el-dialog>
    <el-dialog
      title="报表申请修改信息"
      :visible.sync="detailDialogVisible"
      :close-on-click-modal="false"
      class="dialog770 titleChange"
    >
      <el-form
        :model="showObj"
        ref="showObjForm"
        label-width="135px"
        class="demo-RuleForm"
        size="small"
      >
        <el-form-item label="报表名：">
          <el-input disabled v-model="showObj.name"></el-input>
        </el-form-item>
        <el-form-item label="填报期：">
          <el-input disabled v-model="showObj.date_range"></el-input>
        </el-form-item>
        <el-form-item label="审核状态：">
          <el-input disabled value="已通过"></el-input>
        </el-form-item>
        <el-form-item label="填报单位：">
          <el-input disabled v-model="showObj.company_name"></el-input>
        </el-form-item>
        <el-form-item label="申请修改原因：">
          <el-input disabled v-model="showObj.apply_reason"></el-input>
        </el-form-item>
        <el-form-item label="申请时间：">
          <el-input disabled v-model="showObj.apply_time_format"></el-input>
        </el-form-item>
        <el-form-item label="申请人：">
          <el-input disabled v-model="showObj.user_name"></el-input>
        </el-form-item>
        <el-form-item label="办理意见：">
          <el-input disabled v-model="showObj.handle_reason"></el-input>
        </el-form-item>
        <el-form-item label="办理时间：">
          <el-input disabled v-model="showObj.handle_time_format"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import zdquczbShow from "./../../../DataCollection/DataWrite/notInsert/zdquczbShow/index";
import zdjcqycwbShow from "./../../../DataCollection/DataWrite/notInsert/zdjcqycwbShow/index";
import gyyqjbqkbShow from "./../../../DataCollection/DataWrite/notInsert/zdquczbShow/index";
import { export2Excel } from "@/utils/utils";
export default {
  name: "index",
  components: {
    zdjcqycwbShow,
    gyyqjbqkbShow,
    zdquczbShow,
  },
  data() {
    return {
      report_yidong: 0,
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        //查询对象
        company_name: "",
        applyTime: "",
        dealTime: "",
      },
      showObj: {},
      pageSize: 20,
      exportLabel: "<<点击此处可导出报表",
      total: 0, //表格总数
      detailDialogVisible: false,
      zdjcqyczbId: "",
      editCode: "",
      showDialogVisible: false,
    };
  },
  methods: {
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    getdata(page) {
      this.loading = true;
      this.tableData = [];
      const param = {
        page: page || 1,
        pageSize: this.pageSize,
        status: "2",
      };
      if (this.formInline.applyTime) {
        param["applyStartTime"] = this.$moment(
          this.formInline.applyTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        param["applyEndTime"] = this.$moment(this.formInline.applyTime[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.formInline.company_name !== "") {
        param["name"] = this.formInline.company_name;
      }
      if (this.formInline.dealTime) {
        param["handleStartTime"] = this.$moment(
          this.formInline.dealTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        param["handleEndTime"] = this.$moment(this.formInline.dealTime[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      this.$axios
        .post("/business/insertMonitor/queryApplyChangeList", param)
        .then((res) => {
          res.data.forEach((temp) => {
            if (temp.park_name) {
              temp.company_name = temp.park_name;
              temp.company_phone = temp.park_phone;
            }
          });
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        });
    },
    toDetail(row) {
      this.editCode = row.code;
      this.zdjcqyczbId = row.id;
      this.report_yidong = row.report_yidong;
      this.showDialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleDetail(row) {
      this.showObj = row;
      this.detailDialogVisible = true;
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata();
    },
    reset() {
      this.formInline = {
        company_name: "",
        applyTime: "",
        dealTime: "",
      };
      this.getdata();
    },
    exportData() {
      let column = [
        {
          title: "填报单位",
          key: "company_name",
        },
        {
          title: "报表名",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "申请时间",
          key: "apply_time_format",
        },
        {
          title: "申请修改原因",
          key: "apply_reason",
        },
        {
          title: "办理时间",
          key: "handle_time_format",
        },
        {
          title: "办理意见",
          key: "handle_reason",
        },
      ];
      export2Excel(column, this.tableData, "通过申请");
    },
  },
  created() {
    this.getdata();
  },
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>